export default __webpack_public_path__ + "static/media/mazda.f518d7b5.svg";